import { useContext } from "react";

import { getApplicationsByType } from "@ryde/shared";

import { GlobalAppContext } from "../../contexts";

export const useApplication = () => {
  const { applicationType } = useContext(GlobalAppContext);

  return { applicationType, ...getApplicationsByType(applicationType) };
};
